import { Link } from "@tanstack/react-router";
import { ArrowRight, Mail, MessageCircle } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/language";

import { CONTACT_EMAIL } from "./privacy-page";

// Support channels — also used by the landing page's contact section.
export const SUPPORT_WHATSAPP_URL = "https://wa.me/966507456124";
export const SUPPORT_WHATSAPP_DISPLAY = "+966 50 745 6124";

/** Public contact page at /contact — the landing section's standalone twin. */
export function ContactPage() {
  const { t, dir } = useLanguage();

  return (
    <div dir={dir} className="tw:min-h-dvh tw:bg-background">
      <div className="tw:mx-auto tw:flex tw:w-full tw:max-w-3xl tw:flex-col tw:gap-8 tw:px-6 tw:pb-16 tw:pt-[calc(32px+env(safe-area-inset-top))] tw:md:pt-12">
        <header className="tw:flex tw:flex-col tw:gap-3">
          <Link
            to="/"
            className="tw:inline-flex tw:w-fit tw:items-center tw:gap-1.5 tw:text-sm tw:font-medium tw:text-brand tw:no-underline tw:hover:underline"
          >
            <ArrowRight className="tw:size-4 tw:ltr:-scale-x-100" />
            {t("Mandoob:AppName")}
          </Link>
          <h1 className="tw:m-0 tw:text-3xl tw:font-bold tw:text-foreground">
            {t("Mandoob:Landing.ContactTitle")}
          </h1>
          <p className="tw:m-0 tw:text-sm tw:text-muted-foreground">
            {t("Mandoob:Landing.ContactText")}
          </p>
        </header>

        <div className="tw:grid tw:gap-4 tw:sm:grid-cols-2">
          <div className="tw:flex tw:flex-col tw:items-start tw:gap-3 tw:rounded-2xl tw:border tw:border-border tw:bg-card tw:p-5">
            <span className="tw:flex tw:size-10 tw:items-center tw:justify-center tw:rounded-full tw:bg-brand-50 tw:text-brand">
              <MessageCircle className="tw:size-5" strokeWidth={1.75} />
            </span>
            <h2 className="tw:m-0 tw:text-base tw:font-semibold tw:text-foreground">
              {t("Mandoob:Landing.ContactWhatsApp")}
            </h2>
            <span dir="ltr" className="tw:text-sm tw:text-muted-foreground">
              {SUPPORT_WHATSAPP_DISPLAY}
            </span>
            <Button asChild className="tw:mt-auto tw:gap-2">
              <a href={SUPPORT_WHATSAPP_URL} target="_blank" rel="noreferrer">
                <MessageCircle className="tw:size-4.5" strokeWidth={1.75} />
                {t("Mandoob:Landing.ContactWhatsAppButton")}
              </a>
            </Button>
          </div>

          <div className="tw:flex tw:flex-col tw:items-start tw:gap-3 tw:rounded-2xl tw:border tw:border-border tw:bg-card tw:p-5">
            <span className="tw:flex tw:size-10 tw:items-center tw:justify-center tw:rounded-full tw:bg-brand-50 tw:text-brand">
              <Mail className="tw:size-5" strokeWidth={1.75} />
            </span>
            <h2 className="tw:m-0 tw:text-base tw:font-semibold tw:text-foreground">
              {t("Mandoob:Landing.ContactButton")}
            </h2>
            <span dir="ltr" className="tw:text-sm tw:text-muted-foreground">
              {CONTACT_EMAIL}
            </span>
            <Button asChild variant="outline" className="tw:mt-auto tw:gap-2">
              <a href={`mailto:${CONTACT_EMAIL}`}>
                <Mail className="tw:size-4.5" strokeWidth={1.75} />
                {t("Mandoob:Landing.ContactButton")}
              </a>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
